export default __webpack_public_path__ + "static/media/event-Phoenix-1.f96cacc0.jpg";